module.exports = "tbody:focus {\n    outline: none;\n}\ntbody:focus td.has-link a,\ntbody:focus td.has-link a span {\n    color: #4C87FF;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/bens/frotas/frota-list/frota-list.component.css
 ** module id = 371
 ** module chunks = 0
 **/